<template>
  <v-row no-gutters>
    <v-col cols="4" xl="3" class="pa-0">
      <v-checkbox id="chbShowLables"
        v-model="showLabels"
        dense
        hide-details
        class="checkboxOveride"
        :label="labels.showLabels"
        @change="showLabelChanged"
      ></v-checkbox>
    </v-col>
    <v-col :cols="calculateColsForSecondSwitch()" class="pa-0">
      <v-switch
        v-if="showLabels"
        v-model="selectedDriver"
        dense
        hide-details
        @change="selectedDriverChanged"
        :label="`${selectedDriver ? labels.shown + labels.drivers : labels.shown + labels.vehicles }`"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'RealTimeLabelSwitchComponent',
  props: ['mobileBreakPoint'],
  data() {
    return {
      labels: {
        showLabels: translate('Show labels', 'mapFilters'),
        shown: translate('Shown on label: ', 'mapFilters'),
        drivers: translate('Drivers', 'mapFilters'),
        vehicles: translate('Vehicles', 'mapFilters')
      },
      showLabels: false,
      selectedDriver: false
    }
  },
  methods: {
    calculateColsForSecondSwitch() {
      if (this.mobileBreakPoint) {
        return 4
      } else {
        return 9
      }
    },
    showLabelChanged() {
      store.dispatch('map/changeTooltipsVisibility', this.showLabels)
    },
    selectedDriverChanged() {
      store.dispatch('map/changeLabelsValue', this.selectedDriver)
    }
  }
}
</script>
